/** SquareKit Card grid + Payments summary cards: 1-up mobile, 2-up tablet, 3-up desktop. */
export const SUMMARY_CARDS_GRID =
  'tw:grid tw:grid-cols-1 tw:items-stretch tw:gap-(--spacing-16) tw:md:grid-cols-2 tw:lg:grid-cols-3';

/** Teachers tab summary cards: 1-up mobile, 2-up tablet and desktop. */
export const TWO_SUMMARY_CARDS_GRID =
  'tw:grid tw:grid-cols-1 tw:items-stretch tw:gap-(--spacing-16) tw:md:grid-cols-2';
